import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ConvenientBookingPageStyle from './convenient-booking-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query ConvenientBookingHero {
        contentfulConvenientBookingPage {
          convenientBookingReference {
            hero {
              headline {
                headline
              }
              paragraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={ConvenientBookingPageStyle.heroContentDiv}>
        <h1 className={ConvenientBookingPageStyle.heroTitle}>
          {
            data.contentfulConvenientBookingPage.convenientBookingReference.hero
              .headline.headline
          }
        </h1>
        <div className={ConvenientBookingPageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulConvenientBookingPage.convenientBookingReference.hero
              .paragraph.json
          )}
        </div>

        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
